<template>
  <div class="school-dashboard">
    <div class="dashboard-top-row">
      <!-- 轮播图 -->
      <div class="banner-carousel-container">
        <el-carousel
          height="100%"
          class="banner-carousel"
          arrow="never"
          v-if="banners.length"
        >
          <el-carousel-item v-for="(item, index) in banners" :key="index">
            <div class="banner-item-wrapper" @click="goToNews(item)">
              <img :src="item.imagePc || item.image" class="banner-image" />
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="banner-placeholder" v-else>
          <img src="@/assets/images/communityBj.png" class="banner-image" />
        </div>
      </div>

      <!-- 用户信息卡片 -->
      <div class="user-profile-card">
        <div class="user-card-header">
          <template v-if="user">
            <div class="avatar-wrap" @click="toMyStudy">
              <img
                :src="
                  user.avatarUrl
                    ? user.avatarUrl
                    : require('@/assets/images/dfavatar.png')
                "
                class="user-avatar"
              />
            </div>
            <div class="user-info-text">
              <div class="username-row">
                <span
                  class="username textOverflowOne"
                  style="max-width: 140px"
                  >{{ user.username }}</span
                >
              </div>
              <div class="user-level-img-wrap">
                <img
                  class="user-level-badge-img"
                  v-for="(lvl, idx) in activeEquityLevels"
                  :key="idx"
                  :src="require(`@/assets/images/${lvl}.png`)"
                />
              </div>
              <div class="phone">{{ maskPhone(user.phone) }}</div>
              <div
                class="company-badge textOverflowOne"
                v-if="user && user.companyName"
                :title="user.companyName"
              >
                <span class="company-name-text textOverflowOne">{{
                  user.companyName
                }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="avatar-wrap guest" @click="triggerLogin">
              <img src="@/assets/images/dfavatar.png" class="user-avatar" />
            </div>
            <div class="user-info-text guest" @click="triggerLogin">
              <div class="login-prompt">立即登录</div>
              <div class="phone">登录后同步学习记录</div>
            </div>
          </template>
        </div>
        <div class="user-card-body">
          <div class="stat-card">
            <div class="stat-left">
              <div class="stat-icon-wrap">
                <i class="el-icon-time"></i>
              </div>
              <span class="stat-label">今日时长</span>
            </div>
            <div class="stat-value">
              <span class="num">{{
                getTodayStudyTimeParts(user ? user.todayStudyTime : 0).num
              }}</span>
              <span class="unit">{{
                getTodayStudyTimeParts(user ? user.todayStudyTime : 0).unit
              }}</span>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-left">
              <div class="stat-icon-wrap">
                <i class="el-icon-box"></i>
              </div>
              <span class="stat-label">累计学习</span>
            </div>
            <div class="stat-value">
              <template
                v-if="
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).hours >
                  0
                "
              >
                <span class="num">{{
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).hours
                }}</span>
                <span class="unit">h</span>
                <span class="num" style="margin-left: 4px">{{
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes
                }}</span>
                <span class="unit">min</span>
              </template>
              <template
                v-else-if="
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes >
                  0
                "
              >
                <span class="num">{{
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).minutes
                }}</span>
                <span class="unit">min</span>
              </template>
              <template v-else>
                <span class="num">{{
                  getTotalStudyTimeParts(user ? user.totalStudyTime : 0).seconds
                }}</span>
                <span class="unit">s</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 学习课表 (Featured Course Packages) -->
    <div class="dashboard-section">
      <div class="section-header">
        <div class="header-left">
          <div class="header-indicator"></div>
          <span class="header-title">学习课表</span>
          <span class="header-tag">NEW</span>
        </div>
        <div class="header-right" @click="changeTab(2)">
          <span class="header-more">全部课程</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <div class="packages-grid" v-if="featuredPackages.length">
        <div
          class="package-card"
          v-for="item in featuredPackages.slice(0, 4)"
          :key="item.id"
          @click="toPackageDetails(item)"
        >
          <div class="package-cover-wrap">
            <img :src="item.cover" class="package-cover hoverTransform" />
          </div>
          <div class="package-card-content">
            <div class="package-title-wrap">
              <div class="package-title textOverflowOne">
                {{ item.title }}
              </div>
              <div class="package-subtitle textOverflowOne">
                {{ item.subtitle }}
              </div>
            </div>
            <div class="package-footer">
              <div class="package-subs">
                <i class="el-icon-user"></i>
                <span>{{ item.subscribeCount || 0 }}人订阅</span>
              </div>
              <div class="package-action">立即学习</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三板块分类 -->
    <template v-if="categoryTree.length">
      <div
        class="dashboard-section category-section"
        v-for="cat in categoryTree"
        :key="cat.id"
      >
        <div class="category-row">
          <!-- Sidebar -->
          <div class="category-sidebar">
            <div class="sidebar-header">
              <div class="sidebar-indicator"></div>
              <span class="sidebar-title">{{ cat.name }}</span>
            </div>
            <div class="sidebar-items">
              <div
                class="sidebar-item"
                v-for="child in cat.children"
                :key="child.id"
                @click="toCoursesWithClassify(child.id, child.name)"
              >
                <span class="item-text textOverflowOne">{{ child.name }}</span>
              </div>
              <div
                class="sidebar-more"
                @click="toCoursesWithClassify(cat.id, cat.name)"
              >
                更多
              </div>
            </div>
          </div>

          <!-- 第三板块 右侧推荐课程 -->
          <div class="courses-grid-container">
            <div
              class="courses-grid"
              v-if="cat.courseList && cat.courseList.length"
            >
              <!-- Big Featured Card -->
              <div
                class="big-course-card"
                @click="toDetails(cat.courseList[0])"
              >
                <div class="big-cover-wrap">
                  <img
                    :src="
                      cat.courseList[0].image || cat.courseList[0].mainImage
                    "
                    class="big-cover hoverTransform"
                  />
                </div>
                <div class="big-card-content">
                  <div class="big-title textOverflowTwo">
                    {{ cat.courseList[0].title || cat.courseList[0].name }}
                  </div>
                </div>
              </div>

              <!-- Small Cards (max 4) -->
              <div class="small-courses-box" v-if="cat.courseList.length > 1">
                <div
                  class="small-course-card"
                  v-for="item in cat.courseList.slice(1, 5)"
                  :key="item.id"
                  @click="toDetails(item)"
                >
                  <div class="small-cover-wrap">
                    <img :src="item.image" class="small-cover hoverTransform" />
                  </div>
                  <div class="small-card-content">
                    <div class="small-title textOverflowTwo">
                      {{ item.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-courses-placeholder" v-else>
              <img src="@/assets/images/none.png" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  props: {
    // 轮播图列表
    banners: {
      type: Array,
      default: () => [],
    },
    // 用户个人数据
    user: {
      type: Object,
      default: null,
    },
    // 推荐课程包列表
    featuredPackages: {
      type: Array,
      default: () => [],
    },
    // 课程分类树形结构及推荐课程
    categoryTree: {
      type: Array,
      default: () => [],
    },
    // 企业与等级授权数据（来自 pc/user/company 接口）
    company: {
      type: Object,
      default: null,
    },
  },

  computed: {
    // 获取未过期的授权等级列表 (如 'L1', 'L2')
    activeEquityLevels() {
      console.log(this.company, "this.company");
      if (!this.company || !Array.isArray(this.company.equityClassifyList)) {
        return [];
      }

      const now = Date.now();
      return this.company.equityClassifyList
        .filter((item) => {
          if (!item.equityClassifyName) return false;
          const nameUpper = String(item.equityClassifyName)
            .toUpperCase()
            .trim();
          if (!["L1", "L2", "L3", "L4"].includes(nameUpper)) {
            return false;
          }
          if (!item.endTime) return false;
          let end;
          // 判断是否为纯数字/数字字符串（即时间戳格式）
          if (!isNaN(item.endTime) && !isNaN(Number(item.endTime))) {
            end = new Date(Number(item.endTime));
          } else {
            // 普通的格式化日期字符串，兼容 iOS 替换 '-' 为 '/'
            end = new Date(String(item.endTime).replace(/-/g, "/"));
          }

          const isValid = end instanceof Date && !isNaN(end.getTime());
          const isExpired = isValid ? end.getTime() <= now : true;

          return isValid && !isExpired;
        })
        .map((item) => String(item.equityClassifyName).toUpperCase().trim());
    },
  },
  methods: {
    /**
     * 跳转至关联的新闻资讯详情
     * @param {Object} item - 轮播图项元数据
     * @returns {void}
     */
    goToNews(item) {
      this.$emit("go-to-news", item);
    },
    /**
     * 跳转至我的学习中心
     * @returns {void}
     */
    toMyStudy() {
      this.$emit("to-my-study");
    },
    /**
     * 触发账户登录逻辑
     * @returns {void}
     */
    triggerLogin() {
      this.$emit("trigger-login");
    },
    /**
     * 切换主面板 Tab
     * @param {number} tab - 切换目标的 Tab 索引
     * @returns {void}
     */
    changeTab(tab) {
      this.$emit("change-tab", tab);
    },
    /**
     * 查看课程包详情
     * @param {Object} item - 课程包元数据
     * @returns {void}
     */
    toPackageDetails(item) {
      this.$emit("to-package-details", item);
    },
    /**
     * 点击侧边分类时派发联动切换课程学习页面事件
     * @param {string|number} id - 选中的分类ID
     * @param {string} name - 选中的分类名称
     * @returns {void}
     */
    toCoursesWithClassify(id, name) {
      this.$emit("to-courses-with-classify", { id, name });
    },
    /**
     * 查看课程详情
     * @param {Object} item - 课程元数据
     * @returns {void}
     */
    toDetails(item) {
      this.$emit("to-details", item);
    },
    /**
     * 脱敏隐藏手机号中部四位
     * @param {string|number} phone - 原手机号码
     * @returns {string} 脱敏后的手机号
     */
    maskPhone(phone) {
      if (!phone) return "";
      const pStr = String(phone);
      if (pStr.length >= 7) {
        return pStr.substring(0, 3) + "****" + pStr.substring(pStr.length - 4);
      }
      return pStr;
    },
    /**
     * 格式化今日已看时长（小于1分钟显示秒，大于等于1分钟显示分钟）
     * @param {number} seconds - 秒数
     * @returns {Object} 包含 num (数值) 和 unit (单位) 的对象
     */
    getTodayStudyTimeParts(seconds) {
      const s = Number(seconds) || 0;
      if (s < 60) {
        return { num: s, unit: "s" };
      }
      return { num: Math.floor(s / 60), unit: "min" };
    },
    /**
     * 格式化今日已看时长为分钟
     * @param {number} seconds - 秒数
     * @returns {string} 描述分钟的字符串
     */
    formatTodayStudyTime(seconds) {
      if (!seconds) return "0";
      return Math.floor(seconds / 60).toString();
    },
    /**
     * 格式化累计观看时长为小时、分钟与秒对象形式
     * @param {number} seconds - 秒数
     * @returns {Object} 包含 hours, minutes 和 seconds 的对象
     */
    getTotalStudyTimeParts(seconds) {
      if (!seconds) return { hours: 0, minutes: 0, seconds: 0 };
      const s = Number(seconds) || 0;
      const hours = Math.floor(s / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      const remSec = s % 60;
      return { hours, minutes, seconds: remSec };
    },
    /**
     * 格式化累计观看时长为小时与分钟组合形式
     * @param {number} seconds - 秒数
     * @returns {string} 描述累计时间的字符串
     */
    formatTotalStudyTime(seconds) {
      if (!seconds) return "0";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return hours > 0 ? `${hours}h ${minutes}` : `${minutes}`;
    },
    /**
     * 动态计算轮播图容器的高度，使其在小屏下保持 16:9 比例
     * @name calcCarouselHeight
     * @returns {void}
     */
  },
};
</script>

<style lang="less" scoped>
/* Dashboard Home tab styles */
.school-dashboard {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 48px;
  margin-top: 24px;
}

.dashboard-top-row {
  display: flex;
  gap: 24px;
  width: 100%;
}

.banner-carousel-container {
  flex: 1;
  min-width: 0;
  aspect-ratio: 16 / 9; /* 恢复 16:9 黄金高宽比 */
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .banner-carousel {
    width: 100%;
    height: 100%;
    overflow: hidden;
    /deep/ .el-carousel__container {
      overflow: hidden;
      height: 100% !important;
    }
    /deep/ .el-carousel__item {
      overflow: hidden;
    }
  }
  .banner-item-wrapper {
    width: 100%;
    height: 100%;
  }
  .banner-image {
    width: 100%;
    height: 100%;
  }
  .banner-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
  }
  .banner-placeholder {
    width: 100%;
    height: 100%;
  }
}

.user-profile-card {
  width: 420px; /* 适当加宽个人卡片，以便将 Banner 宽度压缩至更协调的 16:9 高度区间 */
  flex-shrink: 0;
  background: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.user-card-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 24px;
  .avatar-wrap {
    width: 96px;
    height: 96px;
    padding: 4px;
    background: transparent;
    box-shadow: 0px 0px 15px rgba(0, 216, 195, 0.2);
    border-radius: 50%;
    border: 2px solid #00d8c3;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    .user-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .user-info-text {
    margin-top: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .username-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
      .username {
        color: #333333;
        font-size: 20px;
        font-weight: 800;
        line-height: 28px;
      }
    }
    .user-level-img-wrap {
      .user-level-badge-img {
        width: 32px;
        height: 24px;
        object-fit: contain;
        vertical-align: middle;
      }
    }
    .phone {
      color: #7a8a87;
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
    }
    .company-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: 6px;
      padding: 3px 12px;
      background: rgba(0, 216, 195, 0.08);
      border: 1px solid rgba(0, 216, 195, 0.18);
      border-radius: 12px;
      color: #3b4a47;
      font-size: 12px;
      font-weight: 500;
      max-width: 260px;
      box-sizing: border-box;
      i {
        color: #00d8c3;
        font-size: 14px;
      }
      .company-name-text {
        max-width: 210px;
      }
    }
    .login-prompt {
      color: #00d8c3;
      font-size: 20px;
      font-weight: 800;
      line-height: 28px;
      cursor: pointer;
    }
  }
}
.user-card-body {
  border-top: 1px solid #edf2f1;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #f8faf9;

  .stat-card {
    background: #ffffff;
    border: 1px solid #e5eee9;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.02);

    .stat-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .stat-icon-wrap {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background: #e6f8f6;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #00d8c3;
        font-size: 16px;
      }

      .stat-label {
        color: #1f2937;
        font-size: 14px;
        font-weight: 700;
      }
    }

    .stat-value {
      display: flex;
      align-items: baseline;
      gap: 3px;

      .num {
        color: #00d8c3;
        font-size: 20px;
        font-weight: 800;
        line-height: 24px;
      }

      .unit {
        color: #4b5563;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}

.dashboard-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.section-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
    .header-indicator {
      width: 8px;
      height: 32px;
      background: #00d8c3;
      border-radius: 9999px;
    }
    .header-title {
      color: #1b1c1c;
      font-size: 30px;
      font-weight: 700;
      line-height: 36px;
    }
    .header-tag {
      padding: 4px 12px;
      background: rgba(0, 216, 195, 0.1);
      border-radius: 9999px;
      border: 1px solid rgba(0, 216, 195, 0.2);
      color: #00d8c3;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: #3b4a47;
    transition: color 0.3s;
    &:hover {
      color: #00d8c3;
    }
    .header-more {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
    i {
      font-size: 16px;
    }
  }
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  width: 100%;
}

.package-card {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;

  backdrop-filter: blur(6px);
  overflow: hidden;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
      0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  .package-cover-wrap {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #f6f3f2;
    overflow: hidden;
    .package-cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }
  }
  .package-card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .package-title-wrap {
    flex: 1;
    min-height: 52px;
    margin-bottom: 16px;
  }
  .package-title {
    color: #1b1c1c;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .package-subtitle {
    color: #8c9694;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-top: 6px;
  }
  .package-footer {
    padding-top: 16px;
    border-top: 1px solid rgba(186, 202, 198, 0.3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .package-subs {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #3b4a47;
      font-size: 16px;
      font-weight: 400;
      i {
        font-size: 14px;
      }
    }
    .package-action {
      color: #00d8c3;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }
  }
}

.category-row {
  display: flex;
  gap: 0;
  width: 100%;
  align-items: stretch;
}

.category-sidebar {
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
  border-right: 1px solid #e2e8f0;
  padding-right: 24px;
  box-sizing: border-box;
  .sidebar-header {
    display: flex;
    align-items: center;
    gap: 12px;
    .sidebar-indicator {
      width: 6px;
      height: 24px;
      background: #00d8c3;
      border-radius: 9999px;
    }
    .sidebar-title {
      color: #1b1c1c;
      font-size: 18px;
      font-weight: 500;
      line-height: 32px;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .sidebar-items {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: transparent;
  }
  .sidebar-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: transparent;
    transition: color 0.2s;
    color: #3b4a47;
    .item-text {
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
    }
    &:hover {
      color: #00d8c3;
    }
  }
  .sidebar-more {
    width: 100%;
    margin-top: 8px;
    font-size: 14px;
    color: #00d8c3;
    cursor: pointer;
    font-weight: 700;
    align-self: flex-start;
    transition: opacity 0.2s;
    text-align: right;
    &:hover {
      opacity: 0.8;
    }
  }
}

.courses-grid-container {
  flex: 1;
  padding-left: 24px;
  box-sizing: border-box;
}

.courses-grid {
  display: flex;
  width: 100%;
  align-items: stretch;
}

.big-course-card {
  flex: 1.1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding-right: 24px;
  border-right: 1px dashed #e2e8f0;
  box-sizing: border-box;
  .big-cover-wrap {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    background: #f6f3f2;
    border: 1px solid rgba(186, 202, 198, 0.2);
    box-sizing: border-box;
    .big-cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .big-card-content {
    padding-top: 12px;
    box-sizing: border-box;
  }
  .big-title {
    color: #1b1c1c;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
}

.small-courses-box {
  flex: 1;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  column-gap: 24px;
  row-gap: 20px;
  padding-left: 24px;
  box-sizing: border-box;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(50% + 12px);
    width: 1px;
    border-left: 1px dashed #e2e8f0;
    pointer-events: none;
  }
  &::after {
    content: "";
    position: absolute;
    left: 24px;
    right: 0;
    top: 50%;
    height: 1px;
    border-top: 1px dashed #e2e8f0;
    pointer-events: none;
  }
}

.small-course-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-sizing: border-box;
  .small-cover-wrap {
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border-radius: 4px;
    background: #f6f3f2;
    border: 1px solid rgba(186, 202, 198, 0.2);
    box-sizing: border-box;
    .small-cover {
      width: 100%;
      height: 100%;
    }
  }
  .small-card-content {
    padding-top: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .small-title {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    transition: color 0.2s;
  }
  &:hover {
    .small-title {
      color: #00d8c3;
    }
  }
}

.empty-courses-placeholder {
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 282px;
    height: 210px;
  }
}

.hoverTransform {
  transition: transform 0.3s ease;
}
.hoverTransform:hover {
  transform: scale(1.04);
}
</style>
